
import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function PoliticaPrivacidad() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Política de Privacidad
            </h1>
            <p className="text-xl text-gray-600">
              Protección de datos personales y privacidad del usuario
            </p>
          </div>

          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Responsable del tratamiento
              </h2>
              <div className="bg-gray-50 rounded-lg p-6">
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <p className="text-gray-700 mb-2"><strong>Denominación:</strong> PINTOLOT</p>
                    <p className="text-gray-700 mb-2"><strong>Domicilio:</strong> Olot, Girona, España</p>
                    <p className="text-gray-700 mb-2"><strong>Teléfono:</strong> 609 93 65 90</p>
                  </div>
                  <div>
                    <p className="text-gray-700 mb-2"><strong>Email:</strong> info@pintolot.com.es</p>
                    <p className="text-gray-700 mb-2"><strong>Actividad:</strong> Servicios de pintura</p>
                  </div>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Datos que recopilamos
              </h2>
              <div className="space-y-4">
                <div className="border border-gray-200 rounded-lg p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2 flex items-center">
                    <i className="ri-user-line text-[#51b038] mr-2"></i>
                    Datos de identificación
                  </h3>
                  <ul className="text-gray-700 list-disc list-inside space-y-1">
                    <li>Nombre y apellidos</li>
                    <li>Dirección de correo electrónico</li>
                    <li>Número de teléfono</li>
                    <li>Dirección postal</li>
                  </ul>
                </div>

                <div className="border border-gray-200 rounded-lg p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2 flex items-center">
                    <i className="ri-computer-line text-[#51b038] mr-2"></i>
                    Datos de navegación
                  </h3>
                  <ul className="text-gray-700 list-disc list-inside space-y-1">
                    <li>Dirección IP</li>
                    <li>Tipo de navegador</li>
                    <li>Páginas visitadas</li>
                    <li>Tiempo de permanencia</li>
                  </ul>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Finalidades del tratamiento
              </h2>
              <div className="space-y-4">
                <div className="border border-gray-200 rounded-lg p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2 flex items-center">
                    <i className="ri-customer-service-line text-[#51b038] mr-2"></i>
                    Gestión de servicios
                  </h3>
                  <p className="text-gray-700">
                    Procesamos sus datos para gestionar sus solicitudes de presupuesto, proporcionar 
                    nuestros servicios de pintura y mantener la relación comercial.
                  </p>
                  <p className="text-sm text-gray-600 mt-2">
                    <strong>Base legal:</strong> Ejecución de contrato y consentimiento
                  </p>
                </div>

                <div className="border border-gray-200 rounded-lg p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2 flex items-center">
                    <i className="ri-mail-line text-[#51b038] mr-2"></i>
                    Comunicaciones comerciales
                  </h3>
                  <p className="text-gray-700">
                    Con su consentimiento, le enviaremos información sobre nuestros servicios, 
                    ofertas especiales y novedades de la empresa.
                  </p>
                  <p className="text-sm text-gray-600 mt-2">
                    <strong>Base legal:</strong> Consentimiento del interesado
                  </p>
                </div>

                <div className="border border-gray-200 rounded-lg p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2 flex items-center">
                    <i className="ri-bar-chart-line text-[#51b038] mr-2"></i>
                    Análisis y mejora
                  </h3>
                  <p className="text-gray-700">
                    Analizamos el uso del sitio web para mejorar nuestros servicios y la experiencia 
                    del usuario.
                  </p>
                  <p className="text-sm text-gray-600 mt-2">
                    <strong>Base legal:</strong> Interés legítimo
                  </p>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Conservación de datos
              </h2>
              <div className="bg-blue-50 rounded-lg p-6">
                <p className="text-gray-700 mb-4">
                  Conservaremos sus datos personales durante el tiempo necesario para cumplir con las 
                  finalidades para las que fueron recogidos:
                </p>
                <ul className="text-gray-700 list-disc list-inside space-y-2">
                  <li><strong>Datos de clientes:</strong> Durante la relación comercial y 6 años adicionales</li>
                  <li><strong>Datos de contacto:</strong> Hasta que retire su consentimiento</li>
                  <li><strong>Datos de navegación:</strong> Máximo 2 años</li>
                </ul>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Sus derechos
              </h2>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="border border-gray-200 rounded-lg p-4">
                  <h3 className="text-md font-semibold text-gray-900 mb-2 flex items-center">
                    <i className="ri-eye-line text-[#51b038] mr-2"></i>
                    Acceso
                  </h3>
                  <p className="text-sm text-gray-700">
                    Conocer qué datos tenemos sobre usted
                  </p>
                </div>

                <div className="border border-gray-200 rounded-lg p-4">
                  <h3 className="text-md font-semibold text-gray-900 mb-2 flex items-center">
                    <i className="ri-edit-line text-[#51b038] mr-2"></i>
                    Rectificación
                  </h3>
                  <p className="text-sm text-gray-700">
                    Corregir datos inexactos o incompletos
                  </p>
                </div>

                <div className="border border-gray-200 rounded-lg p-4">
                  <h3 className="text-md font-semibold text-gray-900 mb-2 flex items-center">
                    <i className="ri-delete-bin-line text-[#51b038] mr-2"></i>
                    Supresión
                  </h3>
                  <p className="text-sm text-gray-700">
                    Solicitar la eliminación de sus datos
                  </p>
                </div>

                <div className="border border-gray-200 rounded-lg p-4">
                  <h3 className="text-md font-semibold text-gray-900 mb-2 flex items-center">
                    <i className="ri-forbid-line text-[#51b038] mr-2"></i>
                    Oposición
                  </h3>
                  <p className="text-sm text-gray-700">
                    Oponerse al tratamiento de sus datos
                  </p>
                </div>

                <div className="border border-gray-200 rounded-lg p-4">
                  <h3 className="text-md font-semibold text-gray-900 mb-2 flex items-center">
                    <i className="ri-download-line text-[#51b038] mr-2"></i>
                    Portabilidad
                  </h3>
                  <p className="text-sm text-gray-700">
                    Recibir sus datos en formato estructurado
                  </p>
                </div>

                <div className="border border-gray-200 rounded-lg p-4">
                  <h3 className="text-md font-semibold text-gray-900 mb-2 flex items-center">
                    <i className="ri-pause-line text-[#51b038] mr-2"></i>
                    Limitación
                  </h3>
                  <p className="text-sm text-gray-700">
                    Limitar el tratamiento en ciertas circunstancias
                  </p>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Medidas de seguridad
              </h2>
              <div className="border border-gray-200 rounded-lg p-6">
                <p className="text-gray-700 mb-4">
                  Hemos implementado medidas técnicas y organizativas apropiadas para proteger sus datos 
                  personales contra:
                </p>
                <ul className="text-gray-700 list-disc list-inside space-y-2">
                  <li>Acceso no autorizado</li>
                  <li>Alteración, pérdida o destrucción</li>
                  <li>Tratamiento no autorizado</li>
                  <li>Divulgación accidental</li>
                </ul>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Transferencias internacionales
              </h2>
              <div className="bg-yellow-50 rounded-lg p-6">
                <p className="text-gray-700">
                  Algunos de nuestros proveedores de servicios pueden estar ubicados fuera del Espacio 
                  Económico Europeo. En estos casos, nos aseguramos de que existan garantías adecuadas 
                  para la protección de sus datos personales.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Ejercicio de derechos y contacto
              </h2>
              <div className="bg-green-50 rounded-lg p-6">
                <p className="text-gray-700 mb-4">
                  Para ejercer sus derechos o resolver cualquier duda sobre esta política de privacidad, 
                  puede contactarnos:
                </p>
                <div className="space-y-2 text-gray-700">
                  <p className="flex items-center">
                    <i className="ri-mail-line text-[#51b038] mr-2"></i>
                    <strong>Email:</strong> info@pintolot.com.es
                  </p>
                  <p className="flex items-center">
                    <i className="ri-phone-line text-[#51b038] mr-2"></i>
                    <strong>Teléfono:</strong> 609 93 65 90
                  </p>
                  <p className="flex items-center">
                    <i className="ri-map-pin-line text-[#51b038] mr-2"></i>
                    <strong>Dirección:</strong> Olot, Girona, España
                  </p>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Autoridad de control
              </h2>
              <div className="border border-gray-200 rounded-lg p-6">
                <p className="text-gray-700 mb-4">
                  Si considera que el tratamiento de sus datos no se ajusta a la normativa, puede 
                  presentar una reclamación ante la Agencia Española de Protección de Datos:
                </p>
                <div className="space-y-2 text-gray-700">
                  <p><strong>Web:</strong> www.aepd.es</p>
                  <p><strong>Teléfono:</strong> 901 100 099</p>
                  <p><strong>Dirección:</strong> C/ Jorge Juan, 6, 28001 Madrid</p>
                </div>
              </div>
            </section>

            <div className="text-center mt-12 pt-8 border-t border-gray-200">
              <p className="text-sm text-gray-500">
                Última actualización: Diciembre 2024
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
